<app-dialog-header title="Bulk visit transform" (closeClicked)="onCancel()">
</app-dialog-header>

<mat-dialog-content>
  <p>
    Selected <strong>{{ visits.length }}</strong> visit(s). Choose a target status and the system
    will apply it to every eligible visit. Ineligible visits are skipped — nothing else is changed.
  </p>

  <form [formGroup]="form">
    <mat-form-field style="width:100%">
      <mat-label>Target status</mat-label>
      <mat-select
        formControlName="targetStatus"
        (selectionChange)="onTargetChange($event.value)"
      >
        @for (target of targets; track target) {
          <mat-option [value]="target">{{ target }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    @if (summary) {
      <p>
        <strong>{{ summary.eligible.length }}</strong> eligible,
        <strong>{{ summary.alreadyInTarget.length }}</strong> already in target,
        <strong>{{ summary.ineligible.length }}</strong> blocked by status rules.
      </p>
    }

    @if (summary && (summary.target === VisitStatus.CANCELLED || summary.target === VisitStatus.REFERRED)) {
      @if (loaded && validReasons.length > 0) {
        <mat-form-field style="width:100%">
          <mat-label>Booking reason</mat-label>
          <mat-select
            formControlName="bookingReason"
            [compareWith]="compareById"
            (selectionChange)="reasonChanged($event.value)"
          >
            @for (reason of validReasons; track reason) {
              <mat-option [value]="reason">{{ reason.description }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      @if (loaded && validReasons.length === 0) {
        <p>No booking reasons configured for this transform — proceeding without one.</p>
      }
      @if (notesVisible) {
        <mat-form-field style="width:100%">
          <mat-label>Notes</mat-label>
          <textarea formControlName="notes" matInput rows="3"></textarea>
        </mat-form-field>
      }
    }

    @if (summary && summary.target === VisitStatus.AUTO) {
      <mat-form-field style="width:100%">
        <mat-label>AutoBook profile override (optional)</mat-label>
        <mat-select formControlName="autoBookProfile" [compareWith]="compareById">
          <mat-option [value]="null">— No override —</mat-option>
          @for (profile of profiles; track profile) {
            <mat-option [value]="profile">{{ profile.description }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button
    mat-raised-button
    color="primary"
    [disabled]="!canSubmit"
    (click)="onConfirm()"
  >
    Apply to {{ summary?.eligible?.length ?? 0 }} visit(s)
  </button>
</mat-dialog-actions>
